module.exports = "<div class=\"row booking-color-selection\"\n     ng-class=\"$ctrl.colorRowClass\"\n     ng-repeat=\"colorRow in $ctrl.colorRows\">\n\n    <div class=\"col\" on-tap=\"$ctrl.selectColor(color)\"\n         ng-class=\"$ctrl.colorColClass\"\n         ng-repeat=\"color in colorRow\">\n\n        <i class=\"icon ion-ios-checkmark\" ng-style=\"{'color': color}\" ng-if=\"$ctrl.color == color\"></i>\n        <i class=\"icon ion-record\" ng-style=\"{'color': color}\" ng-if=\"$ctrl.color != color\"></i>\n    </div>\n</div>\n\n";


//////////////////
// WEBPACK FOOTER
// ./src/modules/main/components/booking-color-selection/booking-color-selection.html
// module id = 920
// module chunks = 0